import React from 'react';
import styles from './index.less';
import classNames from 'classnames/bind';
import { ChannelSupplierBankDto } from '#services/api';
import BankCardHoverPopover, { buildItems } from './BankCardHoverPopover';

const cx = classNames.bind(styles);

interface Props {
  value: ChannelSupplierBankDto
  type: 'renderLabel' | 'renderSelectedItem' | 'card';
  style?: React.CSSProperties;
  className?: string;
}

const BankCard = (props: Props) => {
  const { value, type, style, className } = props;
  const items = buildItems(value);

  if (type === 'renderLabel') {
    return (
      <div style={style} className={cx('bank-card-render-label__container', className)}>
        {
          items.map((item, index) => {
            return (
              <div className={cx('bank-card-render-label__item')} key={index}>
                <div className={cx(item.key === 'bank_account' ? 'black-bold-text' : 'bank-card-render-label__item-label')}>{item.label}：</div>
                <div className={cx(item.key === 'bank_account' ? 'black-bold-text' : 'bank-card-render-label__item-value')}>{item.value}</div>
              </div>
            )
          })
        }
      </div>
    )
  }

  if (type === 'renderSelectedItem') {
    return (
      <div style={style} className={cx('render-selected-item__container', className)}>
        {
          items.map((item, index) => {
            if (!['bank_account', 'bank_account_name'].includes(item.key)) {
              return null
            }
            return (
              <div className={cx('render-selected-item__item')} key={index}>
                <div className={cx('render-selected-item__item-label')}>{item.label}：</div>
                <div className={cx(item.key === 'bank_account' ? '' : 'render-selected-item__item-value')}>{item.value}</div>
              </div>
            )
          })
        }
      </div>
    )
  }

  if (type === 'card') {
    return (
      <BankCardHoverPopover value={value}>
        <div style={style} className={cx('card__container', className)}>
          {
            items.map((item, index) => {
              if (!['bank_account', 'bank_account_name'].includes(item.key)) {
                return null
              }
              return (
                <div className={cx('card__item')} key={index}>
                  <div className={cx('card__item-label')}>{item.label}：</div>
                  <div className={cx(item.key === 'bank_account' ? 'card__item-value-black' : 'card__item-value')}>{item.value}</div>
                </div>
              )
            })
          }
        </div>
      </BankCardHoverPopover>
    )
  }

  return null;
}

export default BankCard;
